import React from 'react';

/**
 * Create and initialize a context for the Table component
 */
export default React.createContext({
  compact: false,
});
